export default __webpack_public_path__ + "static/media/building.44c7e001.webp";